
export const cSlotTypes = {
  normal: 0,
  temp: 1,
  finished: 2,
};
export const cCards = (id) => {
  const cards = {
    1: 'card-heart/heart_1.png',
    2: 'card-heart/heart_2.png',
    3: 'card-heart/heart_3.png',
    4: 'card-heart/heart_4.png',
    5: 'card-heart/heart_5.png',
    6: 'card-heart/heart_6.png',
    7: 'card-heart/heart_7.png',
    8: 'card-heart/heart_8.png',
    9: 'card-heart/heart_9.png',
    10: 'card-heart/heart_10.png',
    11: 'card-heart/heart_J.png',
    12: 'card-heart/heart_Q.png',
    13: 'card-heart/heart_K.png',
    14: 'card-diamond/diamond_1.png',
    15: 'card-diamond/diamond_2.png',
    16: 'card-diamond/diamond_3.png',
    17: 'card-diamond/diamond_4.png',
    18: 'card-diamond/diamond_5.png',
    19: 'card-diamond/diamond_6.png',
    20: 'card-diamond/diamond_7.png',
    21: 'card-diamond/diamond_8.png',
    22: 'card-diamond/diamond_9.png',
    23: 'card-diamond/diamond_10.png',
    24: 'card-diamond/diamond_J.png',
    25: 'card-diamond/diamond_Q.png',
    26: 'card-diamond/diamond_K.png',
    27: 'card-spade/spade_1.png',
    28: 'card-spade/spade_2.png',
    29: 'card-spade/spade_3.png',
    30: 'card-spade/spade_4.png',
    31: 'card-spade/spade_5.png',
    32: 'card-spade/spade_6.png',
    33: 'card-spade/spade_7.png',
    34: 'card-spade/spade_8.png',
    35: 'card-spade/spade_9.png',
    36: 'card-spade/spade_10.png',
    37: 'card-spade/spade_J.png',
    38: 'card-spade/spade_Q.png',
    39: 'card-spade/spade_K.png',
    40: 'card-club/club_1.png',
    41: 'card-club/club_2.png',
    42: 'card-club/club_3.png',
    43: 'card-club/club_4.png',
    44: 'card-club/club_5.png',
    45: 'card-club/club_6.png',
    46: 'card-club/club_7.png',
    47: 'card-club/club_8.png',
    48: 'card-club/club_9.png',
    49: 'card-club/club_10.png',
    50: 'card-club/club_J.png',
    51: 'card-club/club_Q.png',
    52: 'card-club/club_K.png',
  };
  return cards[id];
};

export const cGameStatus = {
  showRule: 0,
  start: 1,
  playing: 2,
  menu: 3,
  noMoreMoves: 4,
  finished: 5,
};



// WEBPACK FOOTER //
// ./src/common/constants.js